import React from 'react';
import { Container, Tip } from './Tooltip.styles';
import { useRef, useState } from 'react';

interface TooltipProps {
	children?: any;
	content?: any;
	disabled?: boolean;
	widthContainer?: string;
	withoutBreakLine?: boolean;
	testid?: string;
}

export const Tooltip = ({
	children,
	content,
	disabled,
	widthContainer,
	withoutBreakLine,
	testid,
}: TooltipProps): JSX.Element => {
	const [actived, setActived] = useState<boolean>(false);
	const [height, setHeight] = useState(0);
	const tipRef = useRef<any>(null);
	const contentRef = useRef<any>(null);

	const { top, left, width } =
		contentRef.current?.getBoundingClientRect() || {};

	const showTip = () => {
		setTimeout(() => {
			const { height: currentHeight } =
				tipRef.current?.getBoundingClientRect() || {};

			currentHeight && setHeight(currentHeight);
		}, 10);
		setActived(true);
	};

	const hiddenTip = () => {
		setTimeout(() => {
			const { height: currentHeight } =
				tipRef.current?.getBoundingClientRect() || {};

			currentHeight && setHeight(currentHeight);
		}, 10);
		setActived(false);
	};

	if (disabled) {
		return <></>;
	}

	return (
		<Container
			data-testid={testid}
			onMouseEnter={showTip}
			onMouseLeave={hiddenTip}
			ref={contentRef}
		>
			<Tip
				withoutBreakLine={withoutBreakLine}
				actived={actived && !disabled}
				ref={tipRef}
				height={height}
				top={top}
				left={left}
				width={width}
				widthContainer={widthContainer}
			>
				{content}
			</Tip>
			{children}
		</Container>
	);
};
